import VueBaseController from '../../vue_base'

export class IndexController extends VueBaseController {
  static get COMPONENT() {
    return () => import('@/vue/pages/users/ai_content/content_types/index.vue')
  }
}

export class NewController extends VueBaseController {
  static get COMPONENT() { return () => import('@/vue/pages/users/ai_content/content_types/new.vue') }
}

export class EditController extends VueBaseController {
  static get COMPONENT() { return () => import('@/vue/pages/users/ai_content/content_types/edit.vue') }

  static values = {
    name: String,
    slug: String,
    model: String,
    topP: Number,
    temperature: Number,
    frequencyPenalty: Number,
    presencePenalty: Number,
    maxTokens: Number,
    completions: Number,
    messages: Array,
    locationBased: Boolean,
    contentTypeId: String,
    regionalDialect: String,
    responseFormat: Object,
    apiType: String,
    reasoningEffort: String,
    instructions: String,
    inputTemplate: String,
    tools: Object
  }

  connect() {
    super.connect({
      currentName: this.nameValue,
      currentSlug: this.slugValue,
      currentModel: this.modelValue,
      currentTopP: this.topPValue,
      currentTemperature: this.temperatureValue,
      currentFrequencyPenalty: this.frequencyPenaltyValue,
      currentPresencePenalty: this.presencePenaltyValue,
      currentMaxTokens: this.maxTokensValue,
      currentCompletions: this.completionsValue,
      currentMessages: this.messagesValue,
      locationBased: this.locationBasedValue,
      contentTypeId: this.contentTypeIdValue,
      currentReasoningEffort: this.reasoningEffortValue,
      currentRegionalDialect: this.regionalDialectValue,
      currentResponseFormat: this.responseFormatValue,
      currentApiType: this.apiTypeValue,
      currentInstructions: this.instructionsValue,
      currentInputTemplate: this.inputTemplateValue,
      currentTools: this.toolsValue
    })
  }
}
